import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CalistDataActions,
  CalistDataPipes,
  CalistDataSelectors,
} from './calist-data.feature';
import { Observable } from 'rxjs';
import { CA } from 'src/app/shared/entities/ca';
import { PageDataState } from '../../page-data/page-data.types';

const Pipes = CalistDataPipes;
const Actions = CalistDataActions;
const Selectors = CalistDataSelectors;

@Injectable({
  providedIn: 'root',
})
export class CalistDataService {
  private store = inject(Store);

  data$: Observable<CA[] | null> = this.store.pipe(Pipes.selectData);

  isLoading$: Observable<boolean> = this.store.select(
    Selectors.selectIsLoading,
  );

  isLoaded$: Observable<boolean> = this.store.select(Selectors.selectIsLoaded);
  isError$: Observable<boolean> = this.store.select(Selectors.selectIsError);
  state$: Observable<PageDataState<void, CA[]>> = this.store.select(
    Selectors.selectPageDataState,
  );

  ensure(options?: { suppressErrorNotification?: boolean }) {
    this.store.dispatch(
      Actions.ensure({
        dataParams: undefined,
        suppressErrorNotification: options?.suppressErrorNotification,
      }),
    );
  }

  load(options?: { suppressErrorNotification?: boolean }) {
    this.store.dispatch(
      Actions.load({
        dataParams: undefined,
        suppressErrorNotification: options?.suppressErrorNotification,
      }),
    );
  }

  clear() {
    this.store.dispatch(Actions.clear());
  }

  transform(transformation: (data: CA[]) => CA[]) {
    this.store.dispatch(Actions.transform({ transformation }));
  }
}
